import cn from 'clsx';
import {
  Checkbox,
  FormField,
  IconFunctionalInformation12,
  Switch,
  Tooltip,
  UIText1,
  useDeviceType,
} from '@cian/ui-kit';
import { NBSP } from 'shared/common/constants';

import { EFieldName } from 'shared/mortgageMiniCalculator/constants/enum';
import styles from './styles.css';

interface IInsuranceFieldProps {
  lifeInsurance: boolean;
  onChange: (value: boolean) => void;
}

const InsuranceFieldMobile: React.FC<IInsuranceFieldProps> = ({ lifeInsurance, onChange }) => {
  return (
    <div className={styles.root}>
      <Tooltip
        title={`Страхование жизни — не обязательно, но банк повысит ставку при отказе от${NBSP}страховки.`}
        placement="bottom"
      >
        <div className={styles.title}>
          <UIText1>Страхование{NBSP}жизни</UIText1>
          <div className={styles.icon}>
            <IconFunctionalInformation12 color="icon-main-default" />
          </div>
        </div>
      </Tooltip>
      <Switch
        name={EFieldName.lifeInsurance}
        checked={lifeInsurance}
        onChange={(_, value: boolean) => onChange(value)}
      />
    </div>
  );
};

const InsuranceFieldDesktop: React.FC<IInsuranceFieldProps> = ({ lifeInsurance, onChange }) => {
  return (
    <div className={cn(styles.root, styles.desktop)}>
      <Checkbox
        name={EFieldName.lifeInsurance}
        checked={lifeInsurance}
        onChange={(_, value: boolean) => onChange(value)}
        label={
          <Tooltip
            placement="bottom"
            title={`Страхование жизни — не обязательно, но банк повысит ставку при отказе от${NBSP}страховки.`}
          >
            <div className={styles.title}>
              Страхование{NBSP}жизни
              <div className={styles.icon}>
                <IconFunctionalInformation12 color="icon-main-default" />
              </div>
            </div>
          </Tooltip>
        }
      />
    </div>
  );
};

export const InsuranceField: React.FC<IInsuranceFieldProps> = ({ lifeInsurance, onChange }) => {
  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';
  const InsuranceFieldComponent = isDesktop ? InsuranceFieldDesktop : InsuranceFieldMobile;

  return (
    <FormField dataTestId={`field-${EFieldName.lifeInsurance}`} withoutMargin>
      <InsuranceFieldComponent lifeInsurance={lifeInsurance} onChange={onChange} />
    </FormField>
  );
};
